import { AHText, AHTextFonts } from "arkh";
import React, { useMemo } from "react";

export function DescriptionContentDescription(props: { description: string }) {
  const showDescription = useMemo(
    () => props.description.length > 0,
    [props.description.length]
  );
  return showDescription ? (
    <AHText
      type="subtitle"
      font={AHTextFonts.REGULAR}
      spaceHorizontal="medium"
      style={{
        lineHeight: 17,
        maxWidth: 600,
      }}
    >
      {props.description}
    </AHText>
  ) : null;
}
